"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentText = exports.SubTitle = exports.ContentCard = exports.DetailContent = exports.FullNameText = exports.IconWrapper = exports.HeadContent = exports.ContentWrapper = exports.HeaderContent = void 0;
var colors_1 = require("@mui/material/colors");
var system_1 = require("@mui/system");
exports.HeaderContent = (0, system_1.styled)('div')(function () { return ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '10px',
}); });
exports.ContentWrapper = (0, system_1.styled)('div')(function () { return ({
    marginTop: '20px',
}); });
exports.HeadContent = (0, system_1.styled)('div')(function () { return ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '10px',
}); });
exports.IconWrapper = (0, system_1.styled)('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '46px',
        height: '46px',
        borderRadius: '5px',
        display: 'flex',
        placeItems: 'center',
        padding: '10px',
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.main,
    });
});
exports.FullNameText = (0, system_1.styled)('h3')(function () { return ({
    fontSize: '18px',
    fontWeight: '500',
}); });
exports.DetailContent = (0, system_1.styled)('div')(function () { return ({
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '10px',
}); });
exports.ContentCard = (0, system_1.styled)('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        padding: '15px',
        borderRadius: '8px',
        border: "1px solid ".concat(colors_1.grey[300]),
    });
});
exports.SubTitle = (0, system_1.styled)('h6')(function () { return ({
    fontSize: 16,
    fontWeight: 500,
    margin: 0,
}); });
exports.ContentText = (0, system_1.styled)('p')(function () { return ({
    fontSize: 16,
    fontWeight: 400,
    color: "".concat(colors_1.grey[600]),
    margin: 0,
}); });
